<template>
	<el-card class="box-card" shadow="never" style="background-color: #545c64;">
		<div style="text-align: center;margin-bottom: 10px;">
			<router-link to="/center/index">
				<img
				  style="width: 120px; height: 150px"
				  :src="url"
        />
			</router-link>
			  <p style="color: #fff;margin-top: 5px;">{{myDetail.userName}}</p>
		</div>
	  <el-menu
	    class="el-menu-vertical-demo" background-color="#545c64"
		  text-color="#fff"
		  :default-active="defultIndex"
		  active-text-color="#ffd04b" :default-openeds='["1","2","3"]' :router="isRouter">
	    <el-submenu index="1">
	      <template slot="title">
	        <span>成果明细</span>
	      </template>
	      <el-menu-item-group>
	        <el-menu-item index="1-1" route="/center/claim">待认领</el-menu-item>
	        <el-menu-item index="1-2" route="/center/result">我的成果明细</el-menu-item>
	      </el-menu-item-group>
	    </el-submenu>
	    <el-submenu index="2">
	      <template slot="title">
	        <span>新增成果/项目</span>
	      </template>
	      <el-menu-item-group>
	        <el-menu-item index="2-1" route="/center/foreign">新增外文论文</el-menu-item>
	        <el-menu-item index="2-2" route="/center/china">新增中文论文</el-menu-item>
	        <el-menu-item index="2-3" route="/center/drafts">草稿箱</el-menu-item>
	      </el-menu-item-group>
	    </el-submenu>
	    <el-submenu index="3">
	      <template slot="title">
	        <span>个人空间</span>
	      </template>
	      <el-menu-item-group>
	        <el-menu-item index="3-1" route="/center/center">个人中心</el-menu-item>
	        <el-menu-item index="3-2" route="/center/follow">我的关注</el-menu-item>
	        <el-menu-item index="3-3" route="/center/password">修改密码</el-menu-item>
	      </el-menu-item-group>
	    </el-submenu>
			 <el-submenu index="4" v-show="name=='admin'">
	      <template slot="title">
	        <span>课题管理</span>
	      </template>
	      <el-menu-item-group>
	        <el-menu-item index="4-1" route="/center/study">课题列表</el-menu-item>
	      </el-menu-item-group>
	    </el-submenu>
	  </el-menu>
	</el-card>
</template>

<script>
import axios from "axios";
export default {
  name: "index",
  props: {
    defultIndex: {
      type: String,
      defult: "1-1",
    },
  },
  data() {
    return {
      activeName: "second",
      isRouter: true,
      myDetail: {},
      url: "",
      name: document.cookie ? document.cookie.split("loginName=")[1] : "",
    };
  },
  methods: {
    getDetails(id) {
      let currThis = this;
      //我的成果
      axios({
        method: "get",
        url: "/api/member/myDetail/" + id,
      })
        .then(function (response) {
          //console.log(response);
          currThis.myDetail = response.data.data.irUser;
          currThis.url = "../../static" + currThis.myDetail.logUrl;
        })
        .catch(function (thrown) {
          console.log(thrown);
        });
    },
  },
  updated() {
    this.name = document.cookie ? document.cookie.split("loginName=")[1] : "";
  },
  mounted() {
    this.userId = this.$cookies.get("rtnVal");
    this.getDetails(this.userId);
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/center-left.vue